// Small display helpers shared by the builder, run dialog and gallery.
import { isBlank, isValidDate, toText } from "../../../engine";

// "C · Amount" for source columns with headers, "C" for headerless ones,
// plain names for columns created by steps.
export const columnLabel = (column) => {
  if (!column) return "";
  if (column.letter && column.letter !== column.name) return `${column.letter} · ${column.name}`;
  return column.name;
};

export const columnOptions = (table) =>
  (table?.columns || []).map((column) => ({ value: column.name, label: columnLabel(column), type: column.type }));

const numberFormat = new Intl.NumberFormat(undefined, { maximumFractionDigits: 10 });

export const formatCell = (value) => {
  if (isBlank(value)) return "";
  if (typeof value === "number") return numberFormat.format(value);
  if (isValidDate(value)) return toText(value);
  return toText(value);
};

// How a cell is shown in data tables: nulls as ∅, empty text as "".
const cellNumberFormat = new Intl.NumberFormat(undefined, { maximumFractionDigits: 6 });
export const displayValue = (value) => {
  if (value === null || value === undefined) return { text: "∅", muted: true };
  if (typeof value === "string" && value.trim() === "") return { text: '""', muted: true };
  if (typeof value === "number") return { text: cellNumberFormat.format(value), numeric: true };
  if (isValidDate(value)) return { text: toText(value) };
  if (typeof value === "boolean") return { text: value ? "TRUE" : "FALSE" };
  return { text: toText(value) };
};

export const formatCount = (n) => (typeof n === "number" ? n.toLocaleString() : "–");

export const STEP_CATEGORY_COLORS = {
  Rows: "#2563eb",
  Columns: "#7c3aed",
  Transform: "#0891b2",
  Reshape: "#d97706",
  Combine: "#059669",
  Code: "#be185d", // Roadmap 2: AI-written code steps
};
